import axios from 'axios'

import { API_BASE, apiErrorHandler, ApiFilter } from '../api'
import Auth from '../auth'

const NOTIFICATIONS_ENDPOINT = `${API_BASE}notifications/`
const UF_YEAR_2_APPLICATOIN_ENDPOINT = `${API_BASE}uf-year-2-application/`

export default class NotificationAPI {
  constructor(cls) {
    this.cls = cls
  }

  static create(cls) {
    return new NotificationAPI(cls)
  }

  list({pagination, filters}) {
    const filtersMap = {
      // Pagination
      page: ApiFilter.create({key: 'page'}),
      pageSize: ApiFilter.create({key: 'page_size'}),
      
      // Sorting
      ordering: ApiFilter.create({key: 'ordering'}),
      
      // Employee
      recipient: ApiFilter.create({key: 'recipient'}),
    }

    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
      params: ApiFilter.buildParams(filtersMap, {...pagination, ...filters}),
    }

    const promise = axios
      .get(`${NOTIFICATIONS_ENDPOINT}`, options)
      .then(response => response.data)
      .then(data => {
        return {
          ...data,
          results: data.results.map(this.cls.fromAPI),
        }
      })
      .catch(
        apiErrorHandler({
          apiName: 'List NotificationAPI error',
          rethrowErrors: true,
        }),
      )
    return promise
  }
}